import { render, staticRenderFns } from "./DebugTag.vue?vue&type=template&id=18aab152&scoped=true&"
import script from "./DebugTag.vue?vue&type=script&lang=ts&"
export * from "./DebugTag.vue?vue&type=script&lang=ts&"
import style0 from "./DebugTag.vue?vue&type=style&index=0&id=18aab152&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18aab152",
  null
  
)

export default component.exports